import React from "react";
import MaButton from "../../../../Components/UI/ma-button";
import { TfiDownload } from "react-icons/tfi";

export function PayoutsPageHeader({ onExport, onWithdraw }) {
  return (
    <div className="mb-5 md:mb-8">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="my-0 text-[20px] font-semibold tracking-tight text-[#151515] sm:text-[22px] md:text-[24px]">
            Payouts
          </h1>
          <p className="my-0 mt-1 text-[12px] leading-relaxed text-[#6B7280] sm:mt-1.5 sm:text-[13px]">
            Your earnings and withdrawal history
          </p>
        </div>
        <div className="hidden shrink-0 flex-wrap gap-2 lg:flex">
          <MaButton
            startIcon={<TfiDownload className="text-[15px]" />}
            onClick={onExport}
            sx={{
              textTransform: "none",
              color: "#151515",
              bgcolor: "#FFFFFF",
              border: "1px solid #EAEAEA80",
              px: 2.5,
              fontWeight: 600,
              fontSize: "13px",
              "&:hover": {
                borderColor: "#D1D5DB",
                bgcolor: "#F9FAFB",
              },
            }}
          >
            Export
          </MaButton>
          <MaButton
            variant="primary"
            title="Withdraw"
            onClick={onWithdraw}
            sx={{
              bgcolor: "#2E1834",
              px: 2.5,
              fontWeight: 600,
              fontSize: "13px",
            }}
          />
        </div>
        <MaButton
          className="lg:!hidden"
          startIcon={<TfiDownload className="text-[15px]" />}
          onClick={onExport}
          sx={{
            flexShrink: 0,
            textTransform: "none",
            color: "#151515",
            bgcolor: "#FFFFFF",
            border: "1px solid #EAEAEA80",
            px: 2,
            minHeight: "40px",
            fontWeight: 600,
            fontSize: "13px",
            "&:hover": {
              borderColor: "#D1D5DB",
              bgcolor: "#F9FAFB",
            },
          }}
        >
          Export
        </MaButton>
      </div>

      <div className="mt-2 w-full lg:hidden [&>div]:w-full">
        <MaButton
          variant="primary"
          title="Withdraw"
          onClick={onWithdraw}
          sx={{
            width: "100%",
            bgcolor: "#2E1834",
            minHeight: "48px",
            borderRadius: "12px",
            fontWeight: 600,
            fontSize: "14px",
          }}
        />
      </div>
    </div>
  );
}
